(() => {
  if (customElements.get('c2f-hoodie-picker')) return;
  customElements.define('c2f-hoodie-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const root = this.closest('c2f-product');
      const select = this.parentElement.querySelector('select[name="id"]');
      const entries = [...(select?.options || [])].map(option => {
        const parts = option.textContent.split('·').map(part => part.trim());
        return { id: option.value, color: parts[0], size: parts[2]?.split('—')[0].trim() };
      });
      if (!root || !select || entries.length !== 16 || entries.some(entry => !entry.size)) return;
      this.controller = new AbortController();
      const colors = [...new Set(entries.map(entry => entry.color))];
      const sizes = [...new Set(entries.map(entry => entry.size))];
      const controls = [];
      const makeGroup = (key, label, values) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'c2f-hoodie-group';
        const legend = document.createElement('legend');
        legend.textContent = label;
        fieldset.append(legend);
        const row = document.createElement('div');
        row.className = `c2f-hoodie-options c2f-hoodie-options--${key}`;
        values.forEach((value, index) => {
          const choice = document.createElement('label');
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = `hoodie-${key}-${root.id}`;
          radio.value = value;
          const caption = document.createElement('span');
          caption.textContent = value;
          if (key === 'color') caption.className = index === 0 ? 'c2f-hoodie-grey' : 'c2f-hoodie-black';
          choice.append(radio, caption);
          row.append(choice);
          controls.push({ key, value, radio });
          radio.addEventListener('change', event => {
            event.stopPropagation();
            const current = entries.find(entry => entry.id === select.value) || entries[0];
            const target = entries.find(entry => entry[key] === value && entry[key === 'color' ? 'size' : 'color'] === current[key === 'color' ? 'size' : 'color']);
            if (target) {
              select.value = target.id;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, { signal: this.controller.signal });
        });
        fieldset.append(row);
        return fieldset;
      };
      this.replaceChildren(makeGroup('color', this.dataset.colorLabel, colors), makeGroup('size', this.dataset.sizeLabel, sizes));
      const sync = () => {
        const current = entries.find(entry => entry.id === select.value) || entries[0];
        controls.forEach(control => { control.radio.checked = current[control.key] === control.value; });
      };
      select.addEventListener('change', sync, { signal: this.controller.signal });
      sync();
      select.hidden = true;
      this.hidden = false;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
